import { Container } from "react-bootstrap";
import ExcelUploadForm from "../components/ExcelUploadForm";
import { useTranslation } from "react-i18next";

import "../styles/ExcelUploadPage.css";
function ExcelUploadPage() {
    const [t, i18n] = useTranslation("global");
    return (
        <>
            <Container>
                <h1 className="mt-5 mb-5">{t("excel.title")}</h1>
                <p className="custom-p">{t("excel.explanation")}</p>
                <a
                    href="/EJEMPLO_CSV.csv"
                    download="EJEMPLO_CSV.csv"
                    className="btn link custom-a"
                >
                    {t("excel.download")}
                </a>
                <ExcelUploadForm />
            </Container>
        </>
    );
}
export default ExcelUploadPage;
